import normalize from 'json-api-normalizer';

import { formatDateTime } from '../../shared/utilities/date';
import { DossierId } from '../dossier/types';

import {
    PreTripReviewsJSONAPIResponse,
    NormalizedPreTripReview,
    PreTripReviewFromAPI,
    PreTripReview,
} from './types';

export const preTripReviewSerializer = (preTripReview: PreTripReviewFromAPI): PreTripReview => {
    const createdAt = formatDateTime(preTripReview.attributes.createdAt);
    const isValidDate = createdAt && !isNaN(createdAt.getTime());

    return {
        ...preTripReview.attributes,
        feelingsAboutAgentRelationship:
            preTripReview.attributes.feelingsAboutAgentRelationship.replace(
                /(, )?something else, not listed here/g,
                '',
            ),
        createdAt: isValidDate ? createdAt : null,
    };
};

export function serializePreTripReviewsFromAPI(
    json: PreTripReviewsJSONAPIResponse,
): NormalizedPreTripReview {
    // @ts-ignore
    const { preTripReview } = normalize(json);

    const preTripReviewNormalized: NormalizedPreTripReview = {};

    if (!preTripReview) {
        return {};
    }
    Object.entries(preTripReview as { [dossierId: DossierId]: PreTripReviewFromAPI }).forEach(
        ([dossierId, preTripReview]: [DossierId, PreTripReviewFromAPI]) =>
            (preTripReviewNormalized[dossierId] = preTripReviewSerializer(preTripReview)),
    );

    return preTripReviewNormalized;
}
